var _rect, _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChannelsSms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    id: "canvas_background",
    height: 402,
    width: 582,
    y: -1,
    x: -1
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "svg_1",
    fill: "#1F76FF",
    r: 16,
    cy: 16,
    cx: 16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "svg_2",
    fill: "white",
    d: "m16.297979,9.105545c-4.21334,0 -7.64,2.82667 -7.64,6.3c0.01291,0.83336 0.20821,1.65377 0.57217,2.40356c0.36395,0.74978 0.88772,1.41078 1.53449,1.93648l-1.52,3.0466c-0.03134,0.0611 -0.04304,0.1305 -0.03349,0.1985c0.00954,0.068 0.03987,0.1314 0.08683,0.1815c0.04837,0.0494 0.11065,0.0829 0.17855,0.096c0.06789,0.0131 0.13816,0.0052 0.20145,-0.0226l4.08666,-1.9c0.82384,0.2353 1.67655,0.3542 2.53334,0.3533c4.21329,0 7.63999,-2.8267 7.63999,-6.29334c0,-3.46666 -3.4267,-6.3 -7.63999,-6.3zm3.33329,8.16667l-6.33329,0c-0.13261,0 -0.25979,-0.05268 -0.35356,-0.14645c-0.09376,-0.09376 -0.14644,-0.22094 -0.14644,-0.35355c0,-0.13261 0.05268,-0.25979 0.14644,-0.35355c0.09377,-0.09377 0.22095,-0.14645 0.35356,-0.14645l6.33329,0c0.1326,0 0.2598,0.05268 0.3536,0.14645c0.0938,0.09376 0.1464,0.22094 0.1464,0.35355c0,0.13261 -0.0526,0.25979 -0.1464,0.35355c-0.0938,0.09377 -0.221,0.14645 -0.3536,0.14645zm-6.83329,-3.5c0.00172,-0.13207 0.05496,-0.25825 0.14835,-0.35164c0.0934,-0.0934 0.21958,-0.14663 0.35165,-0.14836l4.33333,0c0.13261,0 0.25979,0.05268 0.35355,0.14645c0.09377,0.09376 0.14645,0.22094 0.14645,0.35355c0,0.13261 -0.05268,0.25978 -0.14645,0.35355c-0.09376,0.09377 -0.22094,0.14645 -0.35355,0.14645l-4.33333,0c-0.13261,0 -0.25979,-0.05268 -0.35356,-0.14645c-0.09376,-0.09377 -0.14644,-0.22094 -0.14644,-0.35355z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChannelsSms);
export default __webpack_public_path__ + "static/media/ChannelsSms.b00d2b45374ec5c3171423602e882a20.svg";
export { ForwardRef as ReactComponent };